  import React from 'react'
  import { Box } from 'grommet'
  import { navigate } from 'gatsby'
  
  const encode = (data) => {
    return Object.keys(data)
        .map(key => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
        .join("&");
  }

  class ContactForm extends React.Component {
    constructor(props) {
      super(props);
      this.state = { name: "", email: "", message: "" };
    }

    /* Here’s the juicy bit for posting the form submission */

    handleSubmit = e => {
      fetch("/", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: encode({ "form-name": "contact", ...this.state })
      })
        .then(() => navigate("/contact-success/"))
        .catch(error => alert(error));

      e.preventDefault();
    };

    handleChange = e => this.setState({ [e.target.name]: e.target.value });

    render() {
      const { name, email, message } = this.state;
      return (
        <form onSubmit={this.handleSubmit} name="contact" method="POST" data-netlify="true">
            <input type="hidden" name="form-name" value="contact" />
            <Box direction="row" flex="grow">
                <div>
                <label>Name:</label>
                <input type="text" name="name" value={name} onChange={this.handleChange}/>
                </div>
                <div>
                <label>Email:</label>
                <input type="email" name="email" value={email} onChange={this.handleChange}/>
                </div>
            </Box>
            <label>Message:</label>
            <textarea name="message" value={message} onChange={this.handleChange}></textarea>
            <button type="submit">Send</button>
        </form>
      );
    }
  }

export default ContactForm